module.exports = __webpack_public_path__ + "static/media/港口.bf03f941.svg";